import { useState, useEffect, useCallback } from 'react';
import { ENDPOINTS } from '../api/api';

export function useDeviceIssues(imei) {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    if (!imei) return;
    setLoading(true);
    fetch(ENDPOINTS.deviceIssues(imei))
      .then((r) => r.json())
      .then((data) => { setIssues(Array.isArray(data) ? data : []); })
      .catch(() => setIssues([]))
      .finally(() => setLoading(false));
  }, [imei]);

  useEffect(() => { load(); }, [load]);

  const resolve = useCallback(async (id) => {
    const res = await fetch(ENDPOINTS.resolveIssue(id), { method: 'PATCH' });
    if (!res.ok) throw new Error('Failed to resolve');
    setIssues((prev) => prev.map((i) => i._id === id ? { ...i, status: 'resolved' } : i));
  }, []);

  return { issues, loading, reload: load, resolve };
}
